type Item = {
  span?: number;
};

const DEFAULT_SPAN = 1;
const FULL_ROW_SPAN = 2;

const breakRow = (items: Item[]): void => {
  const count = items
    .map((item) => item.span || DEFAULT_SPAN)
    .reduce((acc, current) => acc + current, 0);

  const isEvenCol = count % 2 === 0;

  if (isEvenCol) {
    return;
  }

  const [lastItem] = items.slice(-1);

  lastItem.span = FULL_ROW_SPAN;
};

export default breakRow;
